import { CATEGORY_TYPES } from '../../ShippingLegacy.constants'

export const DEFAULT_INITIAL_VALUES = {
  id: '',
  carrierId: '',
  categoryId: CATEGORY_TYPES.GLOBAL,
  market: '',
  shippingDelay: '0',
  cost: '',
}
